import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlbums2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAlbums2"><Path fillRule="evenodd" clipRule="evenodd" d="M21.1484 11L19.3286 21H4.67068L2.85082 11H21.1484ZM19.9996 8.5H3.99963V7H19.9996V8.5ZM18.9996 4.5H4.99963V3H18.9996V4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAlbums2;
